export const executeScroll = (id: string, offset = 0) => {
  const topOfElement = document.getElementById(id);
  if (!topOfElement) {
    return;
  }
  const scrollPos = topOfElement.offsetTop - offset;
  window.scroll({ top: scrollPos, behavior: 'smooth' });
};
